import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  expense_account: yup.string().required("Expense account mapping is required"),
  account_payable_account: yup
    .string()
    .required("Account payable account mapping is required"),
  pos_fee_account: yup.string().required("POS fee account mapping is required"),
});

const Validation = ({ expensesAccountMapping }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...expensesAccountMapping,
    },
  });
};

export default Validation;
